<div [ngClass]="{'ds_error': addAttachmentService.isValidationErrorPresent}"
     class="ds-upload  mt-4 mb-5">
  <div class="ds-upload__block d-sm-flex flex-column align-items-center">
    <input (change)="fileChangeFunction($event, addAttachmentService)"
           [multiple]="multipleFilesAllowed"
           class="ds-input"
           data-test="upload"
           type="file"/>
    <div class="ds-upload__block__text d-none d-sm-block"
         data-test="upload-placeholder">{{dragDropHereTextLocalized}}</div>
    <div
      class="ds-upload__block__divider d-none d-sm-block">{{orTextLocalized}}</div>
    <button class="btn btn-primary" type="button">
      <span class="ds-upload__block__button__text">{{buttonTextLocalized}}</span>
      <span class="ds-upload__block__button__text--loading">
        <em class="ds-loading-indicator m-r-xs"></em>
        Uploading
      </span>
    </button>
  </div>
</div>
